import {createSvgIcon} from '@ui/icons/create-svg-icon';

export const ToggleLeftSidebarIcon = createSvgIcon(
  <path d="M2 2H14C14.55 2 15 2.45 15 3V13C15 13.55 14.55 14 14 14H2C1.45 14 1 13.55 1 13V3C1 2.45 1.45 2 2 2ZM13.3 3.7H6V12.3H13.3V3.7Z" />,
  'ToggleLeftSidebarIcon',
  '0 0 16 16',
);
